import { NgModule } from '@angular/core';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { CommonModule } from '@app/common.module';

import { CompanySwitcherComponent } from './company-switcher.component';

import { CompanySwitcherService } from './company-switcher.service';

const COMPONENTS = [
  CompanySwitcherComponent,
];

@NgModule({
  imports: [
    CommonModule,
    NzMessageModule,
  ],
  declarations: COMPONENTS,
  providers: [
    CompanySwitcherService,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class CompanySwitcherModule {}
